import { useEffect } from "react";

const SITE = "https://pnrdecode.com";
const DEFAULT_IMAGE = `${SITE}/og-image.png`;
const DEFAULT_DESC =
  "PNR Decode turns raw Sabre, Amadeus, Galileo & Travelport GDS itineraries into clean, branded, client-ready flight documents in seconds. Convert, brand and share PNRs online.";

/**
 * Per-page SEO tags using React 19's native metadata hoisting.
 * React automatically moves these <meta>/<link> tags into <head> and removes
 * them on route change. The document title is set imperatively so it always
 * wins over the static fallback in index.html.
 */
export function Seo({ title, description, path, image = DEFAULT_IMAGE, noindex = false }) {
  const fullTitle = title
    ? `${title} | PNR Decode`
    : "PNR Decode | Convert GDS itineraries into branded flight documents";
  const url = path ? `${SITE}${path}` : SITE;
  const desc = description || DEFAULT_DESC;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <>
      <meta name="description" content={desc} />
      {path !== undefined && <link rel="canonical" href={url} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PNR Decode" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </>
  );
}

export default Seo;
